module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "my-3",
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.item.pinned) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "left": "-11px",
      "top": "-11px",
      "z-index": "1",
      "width": "30px",
      "height": "30px"
    },
    attrs: {
      "slot": "activator",
      "color": "secondary",
      "dark": "",
      "absolute": "",
      "small": "",
      "fab": ""
    },
    on: {
      "click": function($event) {
        _vm.allowPin = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("fa-thumb-tack")])], 1), _vm._v(" "), _c('span', [_vm._v("Pin post")])], 1) : (_vm.item.pinned) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "left": "-11px",
      "top": "-11px",
      "z-index": "1",
      "width": "30px",
      "height": "30px"
    },
    attrs: {
      "slot": "activator",
      "color": "red",
      "dark": "",
      "absolute": "",
      "small": "",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.removePin()
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("fa-thumb-tack")])], 1), _vm._v(" "), _c('span', [_vm._v("Unpin post")])], 1) : _vm._e(), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "max-width": "300",
      "min-width": "250",
      "z-index": "1",
      "bottom": "",
      "nudge-bottom": 30,
      "nudge-top": -20,
      "nudge-left": 10
    }
  }, [_c('v-list-tile-avatar', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "alt": "User avatar",
      "src": _vm.item && _vm.item.user && _vm.item.user.avatar ? _vm.item.user.avatar : require('@/assets/images/default-avatar.gif')
    }
  })]), _vm._v(" "), _c('avatar-popup', {
    attrs: {
      "item": _vm.item,
      "uid": _vm.item.uid
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "900",
      "text-transform": "capitalize"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    })
  }, [_vm._v(_vm._s(_vm.item.user.firstname + ' ' + _vm.item.user.lastname))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('div', {
    staticStyle: {
      "color": "#000",
      "font-size": "15px"
    }
  }, [_vm._v(_vm._s(_vm.item.user.jobtitle) + " "), (_vm.item.user.jobtitle && _vm.item.company) ? _c('span', [_vm._v("| " + _vm._s(_vm.item.company.companylegalname))]) : _vm._e()])])], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.likes.includes(_vm.getUserDetails.uid)) ? _c('v-icon', {
    staticClass: "secondary--text",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unLikePost(_vm.item, _vm.itemKey)
      }
    }
  }, [_vm._v("fa-thumbs-up")]) : _c('v-icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.likePost(_vm.item, _vm.itemKey)
      }
    }
  }, [_vm._v("fa-thumbs-o-up")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-3 mb-3"
  }, [(!_vm.item.type) ? _c('span', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.item.content))]) : _vm._e(), _vm._v(" "), (_vm.item.type && _vm.item.type === 'rss') ? _c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_vm._v(_vm._s(_vm.item.content))]), _vm._v(" "), (_vm.item.link) ? _c('div', {
    staticClass: "mt-1"
  }, [_c('a', {
    attrs: {
      "rel": "noopener",
      "href": _vm.timelineLink(_vm.item.link),
      "target": "_blank"
    }
  }, [_vm._v("Link to article")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_vm._v(_vm._s(_vm.itemRssFeedCategories.join(' ')))])]) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.item.video) ? _c('v-flex', {
    class: {
      'xs12': true, 'md6': _vm.item.video && _vm.item.attachmentUrl, 'md12': _vm.item.video && !_vm.item.attachmentUrl
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "260px",
      "border": "0px"
    },
    attrs: {
      "allowfullscreen": "",
      "src": _vm.item.video.embedUrl
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.item.attachmentUrl) ? _c('v-flex', {
    staticClass: "text-xs-center",
    class: {
      'xs12': true, 'md6': _vm.item.attachmentUrl && _vm.item.video, 'md12': _vm.item.attachmentUrl && !_vm.item.video
    }
  }, [(_vm.item.type && _vm.item.type === 'rss') ? _c('div', {
    staticClass: "rss-feed-image",
    style: ({
      backgroundImage: ("url(" + (_vm.item.attachmentUrl.replace('http:', 'https:')) + ")")
    })
  }) : _vm._e(), _vm._v(" "), (!_vm.item.type) ? _c('img', {
    staticClass: "py-2",
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "alt": "Post Image",
      "src": _vm.item.attachmentUrl.replace('http:', 'https:')
    }
  }) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "md12": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_c('span', {
    staticClass: "pl-3",
    staticStyle: {
      "font-weight": "900"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    })
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-weight": "900",
      "font-size": "15px"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComments.apply(null, arguments)
      }
    }
  }, [_vm._v("Comments (" + _vm._s(_vm.comments.length || 0) + ")")]), _vm._v(" "), _c('span', [_vm._v("·")]), _vm._v(" Likes (" + _vm._s(_vm.likes.length) + ")")])]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-0 px-2"
  })], 1)], 1), _vm._v(" "), (_vm.comments.length > 0) ? _c('v-list', {
    class: {
      'hidden': !_vm.showComments
    },
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, _vm._l((_vm.comments), function(comment) {
    return _c('v-list-tile', {
      key: comment.commentId,
      attrs: {
        "avatar": ""
      }
    }, [_c('v-menu', {
      attrs: {
        "max-width": "300",
        "min-width": "250",
        "z-index": "1",
        "bottom": "",
        "nudge-bottom": 30,
        "nudge-top": -20,
        "nudge-left": 10
      }
    }, [_c('v-list-tile-avatar', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('img', {
      attrs: {
        "alt": comment && comment.user.avatar ? comment.user.avatar : 'default-avatar.gif',
        "src": comment && comment.user.avatar ? comment.user.avatar : require('@/assets/images/default-avatar.gif')
      }
    })]), _vm._v(" "), _c('avatar-popup', {
      attrs: {
        "item": comment,
        "uid": comment.user.uid
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticStyle: {
        "font-size": "15px",
        "font-weight": "900",
        "text-transform": "capitalize",
        "margin-top": "-17px"
      },
      style: ({
        color: _vm.styles.general.theme_color_dark
      })
    }, [_vm._v(_vm._s(comment.user.firstname + ' ' + comment.user.lastname))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(comment.comment))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('span', [_vm._v(_vm._s(_vm._f("fromNow")(comment.date)))])])], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.comments.length > 0) ? _c('v-divider', {
    class: {
      'hidden': !_vm.showComments
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md9": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "mt-0",
    staticStyle: {
      "padding-bottom": "0px",
      "height": "100%"
    },
    attrs: {
      "full-width": "",
      "single-line": "",
      "label": "Leave a comment"
    },
    model: {
      value: (_vm.comment),
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center pt-2",
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "font-weight": "900",
      "font-size": "22px"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "round": "",
      "flat": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.postComment(_vm.itemKey)
      }
    }
  }, [_vm._v("Post")])], 1)])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "490"
    },
    model: {
      value: (_vm.allowPin),
      callback: function($$v) {
        _vm.allowPin = $$v
      },
      expression: "allowPin"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Pin this Post to the top of the activity feed")]), _vm._v(" "), _c('v-card-text', [_vm._v("This will replace any previously pinned post. Are you sure?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.allowPin = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.pinPost();
        _vm.allowPin = false
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6faf6c80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timeline.vue
// module id = 1230
// module chunks = 16 17